let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("dam1i")).then(() => parcelRequire('d9lvP'));